/**
 * Eğer verilen tarih geçmiş bir tarihse bugünün tarihini döndürür,
 * değilse verilen tarihi döndürür.
 * 
 * @param {string|Date} dateInput - Kontrol edilecek tarih (ISO string veya Date objesi)
 * @returns {Date} Geçmiş tarihse bugünün tarihi, değilse verilen tarih
 * 
 * @example
 * // Geçmiş tarih için
 * ensureFutureDate("2024-01-06T21:00:00.000Z") // Bugünün tarihini döndürür
 * 
 * // Gelecek tarih için
 * ensureFutureDate("2026-01-06T21:00:00.000Z") // Verilen tarihi döndürür
 */
export function ensureFutureDate(dateInput) {
  if (!dateInput) {
    return new Date();
  }

  const inputDate = typeof dateInput === 'string' 
    ? new Date(dateInput) 
    : dateInput;

  // Geçersiz tarih kontrolü
  if (isNaN(inputDate.getTime())) {
    return new Date();
  }

  const today = new Date();
  // Bugünün başlangıcını al (saat, dakika, saniye, milisaniye sıfırlanmış)
  today.setHours(0, 0, 0, 0);
  
  // Input tarihinin başlangıcını al
  const dateToCheck = new Date(inputDate);
  dateToCheck.setHours(0, 0, 0, 0);

  // Eğer tarih bugünden önceyse bugünü döndür
  if (dateToCheck < today) {
    return new Date();
  }

  // Değilse verilen tarihi döndür
  return inputDate instanceof Date ? inputDate : new Date(dateInput);
}

